import type { FINANCING_WIDGETS } from '@/pages/JournalPublication/components/PublicationText/constants'
import { EFinancingOfferRoute } from '@/types'

export const MORE_LINKS: Record<keyof typeof FINANCING_WIDGETS, string> = {
  AGENT: EFinancingOfferRoute.FinancingAgentPage,
  'EXPRESS-MFO': EFinancingOfferRoute.MFOPage,
  'ADVANCE-FUNDING': EFinancingOfferRoute.advancePaymentOnFutureHarvest,
}
